import React from 'react';
import { getThemeLabel } from '../labelGetters';

export default function ThemeDisplay({ theme, labels, isNew = false }) {
  const themeId = theme.experienceThemeId || theme.id;
  const displayName = getThemeLabel(themeId, labels) || `Theme #${themeId}`;
  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';

  return (
    <div
      className={`flex items-center gap-2 p-2 bg-gray-50 rounded border ${borderClass}`}
    >
      <i className="fa-regular fa-palette text-purple-500" />
      <span className="text-sm text-gray-700">{displayName}</span>
    </div>
  );
}
